//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { setInstoreOrderParams } from "../../features/instoreOrders/instoreOrdersSlice";
import { SortingStateOption } from "../../models/sorting";
import { useTranslation } from "react-i18next";
import MainTableHeaderCell from "../_layout/MainTableHeaderCell";
import { Fragment } from "react";
//#endregion

//#region INTERFACE
interface Props {
  isAdmin?: boolean;
}
//#endregion

export default function InstoreOrdersTableHeader({ isAdmin = false }: Props) {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Redux
  const dispatch = useAppDispatch();
  const { instoreOrder_params, loading } = useAppSelector(
    (state) => state.instoreOrders
  );
  //#endregion

  //#region LOGIC

  // Set order sorting
  const sortChangedHandler = (option: SortingStateOption) => {
    if (option.column !== null) {
      dispatch(
        setInstoreOrderParams({
          sort: JSON.stringify(option),
        })
      );
    } else {
      dispatch(setInstoreOrderParams({ sort: undefined }));
    }
  };

  //#endregion

  //#region RENDER
  return (
    <thead>
      <tr>
        {/* read */}
        <th
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs font-semibold text-gray-900"
          scope="col"
        />
        {/* order_date */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.orderDate")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          disabled={loading}
          sortName="order_date"
          params={instoreOrder_params}
        />

        {/* order_code */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.orderCode")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          sortName="order_code"
          disabled={loading}
          params={instoreOrder_params}
        />

        {/* order_type */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.orderType")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          disabled={loading}
          sortName="order_type"
          params={instoreOrder_params}
        />

        {/* order_status */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.orderStatus")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          disabled={loading}
          sortName="order_status"
          params={instoreOrder_params}
        />

        {/* external_store_id */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.storeId")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          disabled={loading}
          sortName="external_store_id"
          params={instoreOrder_params}
        />

        {/* store_language */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.language")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          disabled={loading}
          sortName="store_language"
          params={instoreOrder_params}
        />

        {/* delivery_date */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.deliveryDate")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          disabled={loading}
          sortName="delivery_date"
          params={instoreOrder_params}
        />

        {/* store_opening_date */}
        <MainTableHeaderCell
          headerText={t("rituals.openingDate")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
        />

        {/* article_amount */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.items")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          disabled={loading}
          sortName="article_amount"
          params={instoreOrder_params}
        />

        {/* comment a.k.a. extraProjects ;) */}
        <MainTableHeaderCell
          headerText={t("rituals.extraProjects")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
        />

        {/* track_and_trace */}
        <MainTableHeaderCell
          headerText={t("rituals.parcelInfo")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
        />

        {/* export */}
        {isAdmin ? (
          <Fragment>
            <MainTableHeaderCell
              headerText=""
              className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
            />

            {/* delete */}
            <MainTableHeaderCell
              headerText=""
              className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
            />
          </Fragment>
        ) : null}
      </tr>
    </thead>
  );
  //#endregion
}
